import { post } from '../../Services/http';

const logoutBtnElem = document.getElementById('logoutButton');

if (logoutBtnElem) {
  logoutBtnElem.addEventListener('click', () => {
    post('/api/mypage/logout').then(() => (location.href = '/'));
  });
}
